import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "test-modal_page" }
const _hoisted_2 = { class: "countdown flex-column align-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "countdown-time common-color" }
const _hoisted_5 = { class: "test-modal_content" }
const _hoisted_6 = { class: "test-modal_title weight-700" }
const _hoisted_7 = { class: "list mt-3 flex-column align-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "emoji" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "emoji" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "flex-row justify-evenly" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }

import { IonPage } from "@ionic/vue";
import PageModal from "@/components/PageModal.vue";
import { onMounted } from "vue";
import { getBrandImageUrl } from "@/js/brandImages";

interface PropsData {
  correct: any;
  wrong: any;
  remaining: any;
  currentWord: any;
  countdownTime: any;
  onSelect: (option: number, e: any) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VocabularyTestModal',
  props: {
    correct: {},
    wrong: {},
    remaining: {},
    currentWord: {},
    countdownTime: {},
    onSelect: { type: Function }
  },
  emits: ["onFinish"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function onFinish() {
  emit("onFinish");
}

onMounted(() => {
  console.log(props.currentWord);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "test-modal" }, {
    default: _withCtx(() => [
      _createVNode(PageModal, {
        visible: true,
        "bg-color": "white",
        type: "vocabularyTest",
        onOnFinish: onFinish
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _unref(getBrandImageUrl)('ai_smart_reading/countdown_icon.png'),
                alt: ""
              }, null, 8, _hoisted_3),
              _createElementVNode("span", _hoisted_4, "00:" + _toDisplayString(props.countdownTime > 9 ? 10 : "0" + props.countdownTime), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(props.currentWord?.word), 1),
              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "content-explain weight-500 mt-3 mb-3" }, "停留时间超过 10 秒，建议选择不认识", -1)),
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createElementVNode("li", {
                    key: i,
                    class: _normalizeClass(["list-item cursor-pointer flex-row justify-between align-center", {
                  'green-bg': props.currentWord.showAnswer && props.currentWord.answer == i,
                  'red-bg':
                    props.currentWord.myAnswer === i &&
                    props.currentWord.myAnswer !== props.currentWord.answer,
                  'mb-3': i !== 0,
                }]),
                    onClick: ($event: any) => (props.onSelect(i, $event))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(props.currentWord[`option${i}`]), 1),
                    _createElementVNode("div", _hoisted_9, [
                      (props.currentWord.showAnswer && props.currentWord.answer == i)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(getBrandImageUrl)('speed/pleased_emoji.png'),
                            alt: ""
                          }, null, 8, _hoisted_10))
                        : (
                      props.currentWord.myAnswer === i &&
                      props.currentWord.myAnswer !== props.currentWord.answer
                    )
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _unref(getBrandImageUrl)('speed/bad_emoji.png'),
                              alt: ""
                            }, null, 8, _hoisted_11))
                          : (_openBlock(), _createElementBlock("div", _hoisted_12))
                    ])
                  ], 10, _hoisted_8)
                }), 64)),
                _createElementVNode("li", {
                  class: _normalizeClass(["list-item cursor-pointer flex-row justify-between align-center mb-5", {
                  'red-bg':
                    props.currentWord.myAnswer === 6 &&
                    props.currentWord.myAnswer !== props.currentWord.answer,
                }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (props.onSelect(6, $event)))
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "不认识", -1)),
                  _createElementVNode("div", _hoisted_13, [
                    (
                      props.currentWord.myAnswer === 6 &&
                      props.currentWord.myAnswer !== props.currentWord.answer
                    )
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(getBrandImageUrl)('speed/bad_emoji.png'),
                          alt: ""
                        }, null, 8, _hoisted_14))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15))
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'green-word': props.correct > 0 })
                  }, _toDisplayString(props.correct), 3),
                  _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                  _cache[3] || (_cache[3] = _createTextVNode("正确 "))
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'red-word': props.wrong > 0 })
                  }, _toDisplayString(props.wrong), 3),
                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                  _cache[5] || (_cache[5] = _createTextVNode("错误 "))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'green-word': props.remaining > 0 })
                  }, _toDisplayString(props.remaining), 3),
                  _cache[6] || (_cache[6] = _createTextVNode("/50")),
                  _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                  _cache[8] || (_cache[8] = _createTextVNode("答题进度 "))
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})